// Locks page scroll while an overlay is open. Overlays used to each save
// `document.body.style.overflow`, set it to "hidden", and put the saved value
// back on close — which breaks as soon as two are open at once and they close
// in a different order than they opened (the one that closes last restores
// "hidden" it saved from the other, leaving the page unscrollable for good).
// A shared count instead: scroll is locked while any lock is held, and
// restored to what it was originally only when the last one lets go.

let activeLocks = 0;
let originalOverflow = "";

export function lockBodyScroll() {
  if (activeLocks === 0) originalOverflow = document.body.style.overflow;
  activeLocks += 1;
  document.body.style.overflow = "hidden";

  let released = false;
  return function unlockBodyScroll() {
    if (released) return;
    released = true;
    activeLocks -= 1;
    if (activeLocks === 0) document.body.style.overflow = originalOverflow;
  };
}
